import { createComponent } from '@carvana/merch-components';

export const SocialValueSection = createComponent('div', {
  className: 'flex flex-col gap-6xl sm:gap-7xl'
});

export const Container = createComponent('div', {
  className:
    'flex flex-col gap-2xl sm:flex-row-reverse sm:items-center sm:gap-4xl'
});

export const Content = createComponent('div', {
  className: 'flex flex-col items-start gap-xl md:gap-2xl'
});

export const Text = createComponent('p', {
  className: 'mb-md text-text-default t-body-md md:mb-0 md:t-body-lg'
});

export const Disclaimer = createComponent('p', {
  className: 'text-text-default t-body-xs sm:t-body-sm'
});

export const DisclaimerLink = createComponent('a', {
  className:
    't-body-link-xs sm:t-body-link-sm text-text-default !underline underline'
});
